import useViewportSizes from "use-viewport-sizes";

const useIsMobile = ({maxWidth = 800, maxHeight = 800, debounce = 500} = {}) => {
  const [vpWidth, vpHeight] = useViewportSizes(debounce);
  const isMobile = vpWidth <= maxWidth && vpHeight < maxHeight;

  return isMobile;
}

export default useIsMobile;